<template>
  <div class="bubbles">
    <div class="info">
      <h1>{{ this.title }}</h1>
      <p>Stats shown during the selected date range of {{ this.dateRange }}</p>
    </div>
    <ul class="stats">
      <DashboardTile v-for="(stat, index) in this.stats" :key="index"
      :amount="number(stat.amount)"
      :name="stat.display_name"
      :previous-amount="number(stat.previous_amount)"
      :type="stat.type"
      :help="stat.help_text"
      />
    </ul>
  </div>
</template>

<script>
import DashboardTile from '@/components/DashboardTile'

export default {
  name: 'StatBubblesBlock',
  components: {
    DashboardTile
  },
  methods: {
    number (x) {
      x = x || 0
      if (!isFinite(x) || isNaN(x)) x = 0
      return Number(x)
    }
  },
  props: {
    stats: Array,
    title: String,
    dateRange: String
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/__dir';
@import '../../scss/global/__dir';

.bubbles {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    padding: 35px 0;

    @include breakpoint($tablet) {
      flex-direction: row;
      padding-top: 40px;
    }

    @include breakpoint($desktop) {
      padding: 45px 0;
    }
  }
  .stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 1fr));
    flex: 5;
    grid-column-gap: 15px;
    grid-row-gap: 15px;

    @include breakpoint($tablet) {
      grid-template-columns: repeat(3, minmax(100px, 1fr));
      width: 70%;
    }

    @include breakpoint($tablet-landscape) {
      padding-left: 0px;
      grid-template-columns: repeat(3, minmax(100px, 1fr));
    }

    @include breakpoint($desktop) {
      padding-left: 30px;
    }
  }

  .info {
    margin-bottom: 25px;

    @include breakpoint($tablet) {
      width: 100%;
      margin-bottom: 25px;
    }

    @include breakpoint($desktop) {
      width: 30%;
      padding-right: 25px;
      margin-bottom: 0;
    }

    @include breakpoint($desktop) {
      padding-right: 30px;
    }

    h1 {
      font-family: 'Roboto Medium';
      font-size: 24px;
      margin-bottom: 10px;
      color: #000000;
      letter-spacing: 0;
      @include breakpoint($desktop) {

      }
    }
    p {
      font-family: 'Roboto';
      font-size: 13px;
      color: #000000;
      letter-spacing: 0;
      line-height: 18px;
      @include breakpoint($tablet) {
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/components/StatBubblesBlock.vue